export default "__VITE_ASSET__6aSMctoM__"